// alert("Hello! I am an alert box!!");

// button top
$(document).ready(function() {
   let mybutton = $("#myBtn");

   $(window).scroll(function() {
      if ($(document).scrollTop() > 20) { mybutton.css("display", "block");
      } else { mybutton.css("display", "none"); }
   });

   mybutton.click(function() {
      $("html, body").animate({ scrollTop: 0 }, "slow");
   });

});


//slider
$(document).ready(function() {
   var slideIndex = 1;
   var autoSlideInterval;

   showSlides(slideIndex);

   function showSlides(n) {
      var slides = $(".mySlides");
      var dots = $(".dot");

      if (n > slides.length) { slideIndex = 1; }
      if (n < 1) { slideIndex = slides.length; }

      slides.hide();
      dots.removeClass("active");
      slides.eq(slideIndex - 1).show();
      dots.eq(slideIndex - 1).addClass("active");
   }

   function plusSlides(n) {
      clearInterval(autoSlideInterval); 
      showSlides(slideIndex += n);
      startAutoSlide(); 
   }

   function currentSlide(n) {
      clearInterval(autoSlideInterval); 
      showSlides(slideIndex = n + 1);
      startAutoSlide(); 
   }

   function startAutoSlide() {
      autoSlideInterval = setInterval(function() {
         plusSlides(1);
      }, 3000); 
   }

   $(".prev").on("click", function() {
      plusSlides(-1);
   });

   $(".next").on("click", function() {
      plusSlides(1);
   });

   $(".dot").on("click", function() {
      var dotIndex = $(this).index();
      currentSlide(dotIndex);
   });

   startAutoSlide();
});

// filter table
$(document).ready(function () {
   $(".btn").on("click", function () {
      var filterValue = $(this).data("filter");

      // console.log("Tombol di-klik dengan nilai filter:", filterValue);
      $(".btn").removeClass("active");
      $(this).addClass("active");

      if (filterValue === "all") {
         $(".filterDiv").show();
      } else {
         $(".filterDiv").hide();
         $(".filterDiv." + filterValue).show();
      }
   });
});

// /* generate navigator */ 
function generateNavigation(titleElements, navigationList) {
   titleElements.forEach(function(titleElement) {
      var titleText = titleElement.textContent;
      var anchorLink = titleText.toLowerCase().replace(/\s+/g, '-').replace(/\+/g, '-plus');

      titleElement.innerHTML = '<a href="#' + anchorLink + '">' + titleText + '</a>';

      var listItem = document.createElement('li');
      var anchor = document.createElement('a');
      anchor.textContent = titleText;
      anchor.href = '#' + anchorLink;

      listItem.appendChild(anchor);

      navigationList.appendChild(listItem);
   });
}

var titleElements1 = document.querySelectorAll('h2.title');
var navigationList1 = document.getElementById('navigation');
generateNavigation(titleElements1, navigationList1);

var titleElements2 = document.querySelectorAll('h2.title');
var navigationList2 = document.getElementById('breadcrumb-nav');
generateNavigation(titleElements2, navigationList2);


document.querySelectorAll('a[href^="#"]').forEach(anchor => {
   anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href').substring(1);
      const targetElement = document.getElementById(targetId);

      if (targetElement) {
         const offset = 100; 
         const targetPosition = targetElement.getBoundingClientRect().top + window.scrollY - offset;

         window.scrollTo({
            top: targetPosition,
            behavior: 'smooth' 
         });
      }
   });
});

/* higlight navigator */
$(document).ready(function() {
   var links = $('a[href^="#"]');

   function isElementInViewport(element) {
      var rect = element.getBoundingClientRect();
      return (
         rect.top >= 0 &&
         rect.top <= 300 &&
         rect.left >= 0 &&
         rect.bottom <= $(window).height() &&
         rect.right <= $(window).width()
      );
   }

   function updateLinkColors() {
      links.each(function() {
         var targetId = $(this).attr('href').substring(1);
         var targetElement = $('#' + targetId);

         if (targetElement.length && isElementInViewport(targetElement[0])) {
            $(this).css('color', '#ff8000');
         } else {
            // $(this).css('color', '#0b57d0');
            $(this).css('color', '');
         }
      });
   }

   $(window).scroll(updateLinkColors);
   updateLinkColors();
});


// Fungsi untuk menghasilkan JSON-LD Breadcrumb
function generateBreadcrumb(titleElements) {
   var breadcrumbList = [];

   $(titleElements).each(function (index) {
      var titleText = $(this).text().trim();
      var breadcrumbItem = {
         '@type': 'ListItem',
         'position': index + 1,
         'name': titleText,
         'item': {
         '@id': window.location.href + '#' + titleText.toLowerCase().replace(/\s+/g, '-'),
         'name': titleText
         }
      };

      breadcrumbList.push(breadcrumbItem);
   });

   var jsonLdBreadcrumb = {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      'itemListElement': breadcrumbList
   };

   return jsonLdBreadcrumb;
}

var titleElements1 = $('h2.title');
var breadcrumb = generateBreadcrumb(titleElements1);

var scriptElement = $('<script type="application/ld+json">');
scriptElement.text(JSON.stringify(breadcrumb));

$('head').append(scriptElement);




